export const designTheme = {
  light: {
    bg: '#FFF8F0',
    text: '#2A2A2A',
    textSecondary: '#6A6A6A',
    textTertiary: '#8A8A8A',
    accent1: '#FFE4CC',
    accent2: '#FFD4A8',
    border: '#2A2A2A',
    cardBg: '#FFFFFF',
    terminalBg: '#0A0A0A',
    particle: 'rgba(42, 42, 42, 0.6)',
    particleConnection: 'rgba(42, 42, 42, 0.2)'
  },
  dark: {
    bg: '#0A0A0A',
    text: '#FFFFFF',
    textSecondary: '#B0B0B0',
    textTertiary: '#808080',
    accent1: '#1A4D2E',
    accent2: '#2D5F3F',
    border: '#FFFFFF',
    cardBg: '#1A1A1A',
    terminalBg: '#000000',
    particle: 'rgba(255, 255, 255, 0.6)',
    particleConnection: 'rgba(255, 255, 255, 0.2)'
  }
};

export type DesignTheme = typeof designTheme.light;
